export default __webpack_public_path__ + "appointments/static/media/green.df82fe6b.png";